import{BrowserRouter as Wrap}from'react-router-dom'
import{Provider as Prov}from'react-redux'
import reduxStore from'store'
import Router from'router/Router'
import{memo,Suspense as S}from'react'
import{Loader}from'./components'
export default memo(():React.JSX.Element=><S fallback={<Loader full/>}><Prov store={reduxStore}><Wrap><Router/></Wrap></Prov></S>)  